import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";

import { type DataColumns, type DefaultFilterColumns, type OnFilter } from "../../../types/FilterTable";
import { useFullScreen } from "../../../utils/dialog";
import EnhancedTableFilter from "../EnhancedTableFilter";
import { ColumnOrderMenu } from "../Toolbar/ColumnsOrder/ColumnOrderMenu";

export type BaseTableFilterBarProps<T> = {
  allowToEditColumns?: boolean;
  tableName?: string;
  items: Readonly<Array<T>>;
  filterColumn: DataColumns<T>;
  defaultFilters?: DefaultFilterColumns<T>;
  placeholder?: string;
  skipOROperator?: boolean;
  mixpanelEventName?: string;
  reverseOperatorPrecedence?: boolean;
  onFilter: OnFilter<T>;
  tagsLimit?: number;
};

export function TableFilterBar<T>({
  allowToEditColumns,
  items,
  onFilter,
  filterColumn,
  defaultFilters = [],
  placeholder = "Filter table",
  skipOROperator,
  tableName,
  mixpanelEventName,
  reverseOperatorPrecedence,
  tagsLimit = -1,
}: BaseTableFilterBarProps<T>) {
  const { isMobile: smDown } = useFullScreen();

  return (
    <Stack
      direction="row"
      sx={{
        py: 2,
        px: 0,
        justifyContent: "space-between",
        alignItems: "center",
        flex: 1,
      }}
    >
      <EnhancedTableFilter
        tableName={tableName}
        data={items}
        columns={filterColumn}
        onFilter={onFilter}
        limitTags={smDown ? 2 : tagsLimit}
        placeholder={placeholder}
        defaultValue={defaultFilters}
        skipOROperator={skipOROperator}
        mixpanelEventName={mixpanelEventName}
        reverseOperatorPrecedence={reverseOperatorPrecedence}
      />
      {allowToEditColumns && (
        <Box sx={{ marginLeft: 2 }}>
          <ColumnOrderMenu />
        </Box>
      )}
    </Stack>
  );
}
